var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"navigation relative z-header viewport-gutter w-full flex flex-shrink-0 items-center justify-between bg-primary color-white py-4 mb-4"},[_c('div',{staticClass:"container w-full flex items-center justify-between"},[_c('div',[_c('div',{staticClass:"logo"})])])])
}]

export { render, staticRenderFns }